import { queryOptions, useQuery } from '@tanstack/react-query';

import { stripeApi } from '../api/stripe-api';

import { stripeKeys } from './stripe-keys';

export function stripeAccountQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: stripeKeys.account(storeId),
    queryFn: () => stripeApi.get(storeId),
  });
}

export function useStripeAccount(storeId: string) {
  return useQuery(stripeAccountQueryOptions(storeId));
}
